@if (currentUser$ | async) {
    <div class="app-wrapper">
        @let newsCount = news()?.length;
        @if (shouldDisplayAdminBanner() || newsCount) {
            <sfx-sticky-bar>
                @if (shouldDisplayAdminBanner()) {
                    <div
                        class="admin-message"
                        (click)="onAdminBannerClicked()"
                        >{{ 'auth.backoffice_user_info' | translate }}</div
                    >
                }
                @if (newsCount) {
                    <app-news-bar [newsCount]="newsCount"></app-news-bar>
                }
            </sfx-sticky-bar>
        }
        <div class="menu-wrapper">
            <app-sidebar-navigation [urlProjectId]="projectId()"></app-sidebar-navigation>
        </div>
        <div class="main-content-wrapper">
            <router-outlet (activate)="subscribeToRouterOutletActivatedRouteParams()"></router-outlet>
        </div>
    </div>
}

<app-session-status-notification></app-session-status-notification>

<router-outlet [name]="OUTLET_NAMES.SERVICE_CENTER_MODAL_OUTLET"></router-outlet>
<router-outlet [name]="OUTLET_NAMES.SETTINGS_MODAL_OUTLET"></router-outlet>
<router-outlet [name]="OUTLET_NAMES.NEWS_MODAL_OUTLET"></router-outlet>
